// MODIFIED
import { VESSEL_CONFIG } from '../../../common/selectComponents/VesselPicker';
import { DEPARTMENT_CONFIG } from '../../../common/selectComponents/DepartmentPicker';
import { CLIENT_CONFIG } from '../../../common/selectComponents/ClientPicker';
import { EMPLOYEETYPE_CONFIG } from '../../../common/selectComponents/EmployeeTypePicker';
import { POSITION_CONFIG } from '../../../common/selectComponents/PositionPicker';
import { PAYTYPE_CONFIG } from '../../../common/selectComponents/PaytypeTypePicker';
import { PAYROLLPERIOD_CONFIG } from '../../../common/selectComponents/PayrollPeriodPicker';
import { CLASSIFICATION_CONFIG } from '../../../common/selectComponents/ClassificationPicker';
import { COMPANY_CONFIG } from '../../../common/selectComponents/CompanyPicker';

export const UI_TYPES = {
  DROPDOWN: 'dropdown',
  PICKER: 'picker',
  DATE: 'date',
  SELECT_STATIC: 'select_static',
  TEXT: 'text'
};

export const PAYLOAD_TYPES = {
  MAINTENANCE: 'maintenance', // Goes into the [{type, value}] array
  ADDITIONAL: 'additional'    // Goes into the { key: value } object
};

export const FILTER_CONFIG = {
  // -- Maintenance Filters --
  "COMPANY": {
    label: "Company",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: COMPANY_CONFIG
  },
  "PAYTYPE": {
    label: "Paytype",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: PAYTYPE_CONFIG
  },
  "PAYROLLPERIOD": {
    label: "PayrollPeriod",
    uiType: UI_TYPES.PICKER,
    pickerConfig: PAYROLLPERIOD_CONFIG,
    dependsOn: ["PAYTYPE"]
  },
  "CLASSIFICATION": {
    label: "Classification",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: CLASSIFICATION_CONFIG
  },
  "DEPARTMENT": {
    label: "Department",
    uiType: UI_TYPES.PICKER,
    pickerConfig: DEPARTMENT_CONFIG
  },
  "VESSEL": {
    label: "Vessel",
    uiType: UI_TYPES.PICKER,
    pickerConfig: VESSEL_CONFIG
  },
  "CLIENT": {
    label: "Client",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: CLIENT_CONFIG
  },
  "EMPLOYEE_TYPE": {
    label: "Employee Type",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: EMPLOYEETYPE_CONFIG
  },
  "POSITION": {
    label: "Position",
    uiType: UI_TYPES.PICKER,
    pickerConfig: POSITION_CONFIG,
    dependsOn: ["DEPARTMENT"]
  },

  // -- Additional Filters --
  "EFFECTIVE_DATE": {
    label: "Effective Date",
    uiType: UI_TYPES.DATE,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "effectiveDate", // The key name used in additionalApiFilterPayload
    isRequired: false
  },
  
  // ADDED: Example of a Static Dropdown (Non-DB)
  "STATUS": {
    label: "Status",
    uiType: UI_TYPES.SELECT_STATIC,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "status",
    options: [
      { value: 'active', name: 'Active' },
      { value: 'inactive', name: 'Inactive' }
    ]
  },
};

export const SALARY_FILTER_MAP = {
  "COMPANY": "companyId", // if applicable
  "DEPARTMENT": "departmentId",
  "POSITION": "positionId",
  "EMPLOYEE_TYPE": "employeeTypeId",
  "VESSEL": "vesselId",
  "CLASSIFICATION": "classificationId",
  "PAY_TYPE": "payTypeId",
  "LOCATION": "locationId",
  "CLIENT": "clientId"
};

export const TRANSACTION_SALARY_FILTER_MAP = {
  "DEPARTMENT": "departmentId",
  "POSITION": "tempPositionId",      // Transaction uses 'temp'
  "EMPLOYEE_TYPE": "tempEmployeeTypeId",
  "VESSEL": "tempVesselId",
  "CLASSIFICATION": "classificationId",
  "PAY_TYPE": "payTypeId"            // From Compensation Tab
};